import React from 'react';
import { ConfirmationModal, Spinner } from 'seagull';
import RestfulWrapper from "../../../components/RestfulWrapper/RestfulWrapper";
import { useStoreActions } from "../../../contexts";
import styles from "./ActivityLogModal.module.scss";
import GenericError from "../../../components/GenericError/GenericError";
import ActivityLogItem from "../../../components/ActivityLogItem/ActivityLogItem";
import { relationshipModel } from "../../../models";
export default function ActivityLogModal(_ref) {
  let {
    relationshipId,
    dismissModal
  } = _ref;
  const {
    api
  } = useStoreActions();
  const closeModal = () => dismissModal();
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Activity log",
    "data-testid": "activity-log-modal",
    width: "980px",
    textAlignCenter: false,
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, /*#__PURE__*/React.createElement(RestfulWrapper, {
      fetch: () => Promise.all([api.activityLog.get(relationshipId), api.relationship.get(relationshipId)]).then(_ref2 => {
        let [activityLog, relationship] = _ref2;
        return {
          activityLog,
          relationship
        };
      }),
      renderChild: _ref3 => {
        let {
          data: {
            activityLog,
            relationship
          }
        } = _ref3;
        return /*#__PURE__*/React.createElement("div", null, activityLog.map((logItem, idx) => /*#__PURE__*/React.createElement(ActivityLogItem, {
          isFirst: idx === 0,
          isLast: idx === activityLog.length - 1,
          key: logItem.id(),
          vendorName: relationshipModel.sellerFullName(relationship) || '',
          clientName: relationshipModel.buyerFullName(relationship) || '',
          entry: logItem,
          relationship: relationship,
          variant: "transparent"
        })));
      },
      renderLoader: () => /*#__PURE__*/React.createElement(Spinner, {
        centeredInBox: true,
        centerBoxHeight: "100%"
      }),
      renderError: () => /*#__PURE__*/React.createElement(GenericError, null)
    })),
    primaryButtonLabel: "Close",
    onPrimaryButtonClick: closeModal,
    onCloseButtonClick: closeModal
  });
}